<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        Modifier restitution nutritive
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="onClose()"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div
      class="d-flex flex-column mt-6 mx-4"
    >
      <AgrialInputNumber
        v-model.number="parametreModifiable.restitutionNutritive.apportAzote"
        label="N"
        suffix="u"
        :rules="parametreModifiable.restitutionNutritive.apportAzote!= null ? [rules.min, rules.max] : []"
        min="0"
      />
    </div>
    <div
      class="d-flex flex-column mt-6 mx-4"
    >
      <AgrialInputNumber
        v-model.number="parametreModifiable.restitutionNutritive.apportPhosphore"
        label="P"
        suffix="u"
        :rules="parametreModifiable.restitutionNutritive.apportPhosphore!= null ? [rules.min, rules.max] : []"
        min="0"
      />
    </div>
    <div
      class="d-flex flex-column mt-6 mx-4"
    >
      <AgrialInputNumber
        v-model.number="parametreModifiable.restitutionNutritive.apportPotassium"
        label="K"
        suffix="u"
        :rules="parametreModifiable.restitutionNutritive.apportPotassium!= null ? [rules.min, rules.max] : []"
        min="0"
      />
    </div>
    <v-card-actions class="pa-4">
      <v-spacer />
      <AgrButton
        color="primary darken-1"
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        color="primary darken-1"
        :disabled="!isValid"
        @click="save()"
      >
        Valider
      </AgrButton>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'
import {clone} from '@/utils/clone'
import { AgrButton } from '@agrial/ui'
import AgrialInputNumber from '@/components/form/agrial-input-number.vue'

export default {
  name: 'UpdateRestitutionNutritiveModal',
  components: {AgrButton, AgrialInputNumber},
  props: {
    parametre: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      parametreModifiable: {},
      rules: {
        min: value => (value != null && value > 0) || 'Doit être > 0',
        max: value => (value != null && value < 400) || 'Doit être < 400',
      }
    }
  },

  computed: {
    isValid () {
      return (this.parametreModifiable.restitutionNutritive.apportAzote === null || (this.parametreModifiable.restitutionNutritive.apportAzote != null && this.parametreModifiable.restitutionNutritive.apportAzote > 0 && this.parametreModifiable.restitutionNutritive.apportAzote < 400))
        && (this.parametreModifiable.restitutionNutritive.apportPhosphore === null || (this.parametreModifiable.restitutionNutritive.apportPhosphore != null && this.parametreModifiable.restitutionNutritive.apportPhosphore > 0 && this.parametreModifiable.restitutionNutritive.apportPhosphore < 400))
        && (this.parametreModifiable.restitutionNutritive.apportPotassium === null || (this.parametreModifiable.restitutionNutritive.apportPotassium != null && this.parametreModifiable.restitutionNutritive.apportPotassium > 0 && this.parametreModifiable.restitutionNutritive.apportPotassium < 400))
    }
  },

  created () {
    this.parametreModifiable = clone(this.parametre)
    this.parametreModifiable.restitutionNutritive.apportAzote = this.parametre != null && this.parametre.restitutionNutritive.apportAzote!= null ? this.parametre.restitutionNutritive.apportAzote : null
    this.parametreModifiable.restitutionNutritive.apportPhosphore = this.parametre != null && this.parametre.restitutionNutritive.apportPhosphore!= null ? this.parametre.restitutionNutritive.apportPhosphore : null
    this.parametreModifiable.restitutionNutritive.apportPotassium = this.parametre != null && this.parametre.restitutionNutritive.apportPotassium!= null ? this.parametre.restitutionNutritive.apportPotassium : null
  },

  methods: {
    ...mapActions({
      updateAdminComparateurIndicateurNonChiffreMarge: 'comparateurMarge/updateAdminComparateurIndicateurNonChiffreMarge'
    }),

    onClose () {
      this.$emit('close')
    },
    save () {
      this.updateAdminComparateurIndicateurNonChiffreMarge(this.parametreModifiable)
      .then(() => this.$emit('updatedParametre'))
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre { 
  height: 70px;
  background-color: #f1f2f5;
}
</style>